import type { Translate } from '@/shared/api/errors'

/**
 * Huquq kodining ODAM O'QIYDIGAN nomi — BUG-042.
 *
 * <h2>Nima o'lchangan</h2>
 * 2026-08-16, jonli panel (`tests/_sys2-repro.mjs`): rol tahrirlash
 * oynasidagi 140 ta yorliqdan <b>98 tasi</b> xom kod edi —
 * `subscriber.read`, `ledger.adjust`, `crm.lead.reveal`. Tester
 * («KODLAR O'RNIGA TEXT QO'SHISH KK») aynan shuni ko'rgan.
 *
 * <h2>⚠️ NEGA IKKI QISMDAN QURILADI, 115 TA KALIT EMAS</h2>
 * Kod har doim `domen.quyruq` shaklida: 115 huquqda <b>25</b> domen va
 * <b>82</b> quyruq bor (o'lchandi — `permissions.ts` dan). Har kodga
 * alohida kalit yozish 115×3 = 345 satr bo'lardi va yangi huquq
 * qo'shilganda uchala tilda ham UNUTILARDI — kod esa jimgina xom
 * ko'rinishga qaytardi. Domen + quyruq esa 107×3 kalit va har yangi
 * huquq mavjud bo'laklardan yig'iladi.
 *
 * ⚠️ `permissionGroup.*` YANGI lug'at EMAS — u allaqachon bor va
 * `PermissionPicker`/`UserPermissionsPanel` ikkalasi ham o'shani
 * o'qiydi (`UserPermissionsPanel` dagi "Nuqson #4" izohi: ikkinchi
 * lug'at yasash tarjimalarni ajratib yuborardi).
 *
 * <h2>⚠️ NOMA'LUM KOD JIMGINA YO'QOLMAYDI</h2>
 * Backend yangi huquq qo'shsa (panel katalogi hali eski), na domen, na
 * quyruq lug'atda bo'lmaydi. Bunday holatda funksiya BO'SH SATR
 * qaytarmaydi — bo'lakning o'zini qaytaradi, ya'ni eng yomon holatda
 * bugungi ko'rinish qoladi, hech narsa yo'qolmaydi.
 *
 * ⚠️ KODNING O'ZI EKRANDAN OLIB TASHLANMAYDI — u ikkilamchi, mayda
 * matn sifatida yonida turadi. Sabab: qo'llab-quvvatlash xizmati va
 * hujjatlar aynan kod bilan gapiradi ("`ledger.adjust` bering"), va
 * uni yo'qotish nuqsonni ikkinchi tomonga ag'darardi.
 */

/** `subscriber.session.disconnect` → `subscriber` */
export function permissionDomain(code: string): string {
  const dot = code.indexOf('.')
  return dot < 0 ? code : code.slice(0, dot)
}

/** `subscriber.session.disconnect` → `session.disconnect` */
export function permissionAction(code: string): string {
  const dot = code.indexOf('.')
  return dot < 0 ? code : code.slice(dot + 1)
}

/**
 * `ledger.adjust` → «Ledger · Manual adjustment».
 *
 * Nuqtasiz kod (bunday bo'lmasligi kerak, lekin himoya arzon) domen
 * sifatida qaraladi va yolg'iz o'zi qaytadi — ajratgich osilib qolmaydi.
 */
export function permissionLabel(code: string, t: Translate): string {
  const domain = permissionDomain(code)
  const action = permissionAction(code)
  const group = t(`permissionGroup.${domain}`, { defaultValue: domain })
  if (action === domain) return group
  return `${group} · ${t(`permissionAction.${action}`, { defaultValue: action })}`
}
